import React from 'react';
import DashboardContainer from '../../containers/dashboard';

const Dashboard: React.FC = () => {
  return <DashboardContainer />;
};

export default Dashboard;
